module.exports = __webpack_public_path__ + "img/kcbackbutton.f81b1961.svg";